import React, { useRef, useEffect } from 'react';

import styled from 'styled-components';

export default function LockerDivisionInput(props) {
	const { value, setValue, onCancel } = props;
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);
  const spanRef = useRef(null);

	// 입력값 변경 시 너비 자동 조정 //
	useEffect(() => {
    if (inputRef.current && spanRef.current) {
      const textWidth = spanRef.current.offsetWidth;
      const newWidth = Math.min(300, Math.max(40, textWidth + 20));
      inputRef.current.style.width = `${newWidth}px`;
    }
	}, [value]);

  // 입력 필드 포커스 설정 //
  useEffect(() => {
    if (inputRef !== null) {
      setTimeout((inputRef.current.focus()), 250);
    }
  }, [inputRef])

  // 외부 클릭 시 취소 처리 //
  useEffect(() => {
    function handleClickOutside(e) {
      if (e.target.closest('[data-locker-add-button]')) return;

      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        if (onCancel) onCancel();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onCancel])

	function onChangeInput(e) {
    setValue(e.target.value);
	}

  return (
    <TopLevelWrapper ref={wrapperRef}>
      <HiddenSpan ref={spanRef}>{value || 'A'}</HiddenSpan>
      <Input
        ref={inputRef}
        value={value}
        onChange={onChangeInput}
      />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const HiddenSpan = styled.span`
  position: absolute;
  visibility: hidden;
  white-space: nowrap;
  font-family: NotoSansKR-Regular;
  font-size: 14px;
`;

const Input = styled.input`
  box-sizing: border-box;
  text-align: center;
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	padding: 4px 10px;

  max-width: 300px;

	outline: none;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.background};
  color: ${props => props.theme.text};

	::placeholder {
		color: ${props => props.theme.line};
	}
`;
